/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { Tooltip } from 'react-tooltip';

type Props = {
  className?: string
  svgIcon?: string
  titleClass?: string
  descriptionClass?: string
  iconClass?: string
  totalCompletedBooking?: string
  totalCancelledBooking?: string
  totalBooking?: string
  description?: string
}
const TilesWidget6 = (props: Props) => {
  const { className, svgIcon, titleClass, descriptionClass, iconClass, totalCompletedBooking, totalCancelledBooking, totalBooking, description } = props

  return (
    <div className={clsx('card', className)} >
      <div className='card-body d-flex flex-column justify-content-between' style={{ backgroundImage: `url(${toAbsoluteUrl('/media/circle.png')})`, backgroundPosition: 'top right', backgroundRepeat: 'no-repeat', backgroundSize: '75px' }}>
        <KTIcon iconName={svgIcon || ''} className={clsx(iconClass, 'fs-2hx ms-n1 flex-grow-1')} />
        {!svgIcon && (<h2 style={{ color: '#65C098' }}>UZS</h2>)}
        <div className='d-flex flex-column custom-tooltip-trigger' data-tooltip-id='custom-tooltip'>
          <div className={clsx(descriptionClass, 'fw-semibold fs-4 mt-10')}>{description}</div>
          <div className={clsx(titleClass, 'fw-bold mb-0 mt-5')} style={{ fontSize: '40px', color: '#5A98B4' }}>{totalBooking}</div>
        </div>
        <Tooltip
          anchorSelect=".custom-tooltip-trigger"
          place="top"
          float={true}
          className="booking-tooltip"
          style={{
            maxWidth: '280px', // Slightly wider to fit the horizontal layout + multiline
            zIndex: 9999
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}> {/* Flex row for bar + label + bubble */}
            {/* Left indicator bar: Matches the tall light green rectangle in the image */}
            <div style={{
              width: '6px',
              height: '100%',
              backgroundColor: '#ffffff',
              borderRadius: '3px',
              flexShrink: 0,
            }} />

            <div style={{
              backgroundColor: '#ffffff',
              padding: '10px 12px',
              borderRadius: '8px',
              textAlign: 'left',
              boxShadow: '0px 0px 50px 0px rgba(82, 63, 105, 0.15)', // Subtle green-tinted shadow
              flex: 1, // Takes remaining width
              minWidth: 0 // Allows wrapping
            }}>
              <div className='fs-6 text-gray-800'><span className='fs-3' style={{ color: "rgb(101, 192, 152)" }}>● </span> Total Bookings: <b className='fw-bold'>{totalBooking}</b></div>
              <div className='fs-6 text-gray-800'><span className='fs-3' style={{ color: "rgb(101, 192, 152)" }}>● </span> Completed: <b className='fw-bold'>{totalCompletedBooking}</b></div>
              <div className='fs-6 text-gray-800'><span className='fs-3' style={{ color: "rgb(101, 192, 152)" }}>● </span> Cancelled: <b className='fw-bold'>{totalCancelledBooking}</b></div>
            </div>
          </div>
        </Tooltip>
      </div>
    </div>
  )
}

export { TilesWidget6 }
